import { useEffect, useState } from "react";
import CustomPagination from "../Pagination/CustomPagination";
import useStyles from "./style";
import { Box, Flex, Table } from "@mantine/core";
import { useSelector } from "react-redux";
import TableLoader from "../TableLoader";
import { getAllStaffSkypoint } from "../../services/staff";
import { getAllSkypointProvider } from "../../services/skypointProvider";
import {
  getSkaiTokenPackages,
  getSkaiTokenUsage,
} from "../../services/skaiTokens";

const SubscriptionDetailsCard = () => {
  const { profile } = useSelector((state) => state.profile);
  const [staffCurrentPage, setStaffCurrentPage] = useState(1);
  const [providerCurrentPage, setProviderCurrentPage] = useState(1);
  const { classes } = useStyles();
  const {
    staffCount,
    staff,
    loading: staffLoading,
  } = useSelector((state) => state.staff);
  const {
    skypointProviders,
    skypointProvidersCount,
    skypointProvidersLoading,
  } = useSelector((state) => state.skypointProviders);
  const tokenPackages = useSelector((state) => state.skai.tokenPackages);
  const usageData = useSelector((state) => state.skai.usageHistory);
  const usageArray = Array.isArray(usageData) ? usageData : [];
  const existingRecord = usageArray.find(
    (item) => item?.admin === profile?.user?.id,
  );
  const subscribedPackage = tokenPackages.find(
    (item) => item?._id === existingRecord?.aiPackageId,
  );

  useEffect(() => {
    getAllStaffSkypoint(staffCurrentPage, true, true, "");
  }, [staffCurrentPage]);

  useEffect(() => {
    getAllSkypointProvider(providerCurrentPage, "active");
  }, [providerCurrentPage]);

  useEffect(() => {
    getSkaiTokenPackages(true);
    getSkaiTokenUsage(profile?.user?.id);
  }, [profile?.user]);

  return (
    <Box className={classes.card}>
      <Flex className={classes.cardHdr}>
        <p className={classes.cardHdng}>Subscription Details</p>
      </Flex>
      <Box className={classes.tablesParent}>
        <Box className={classes.tableParent1}>
          <Table className={classes.table}>
            <thead>
              <tr>
                <th>Active Staffs</th>
              </tr>
            </thead>
            <tbody>
              {staffLoading ? (
                <tr>
                  <td>
                    <TableLoader />
                  </td>
                </tr>
              ) : staff?.staffs?.length > 0 ? (
                staff?.staffs?.map((staffData) => (
                  <tr key={staffData?._id}>
                    <td>
                      {staffData?.name || ""}
                      {staffData?.role === "admin" ? " (Admin role)" : null}
                      {staffData?.isAdditionalStaff && (
                        <span className={classes.tdAmount}>
                          + ${staffData?.isAdditionalStaff}
                        </span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>No Staff</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Box>
        <Box className={classes.tableParent2}>
          <Table className={classes.table}>
            <thead>
              <tr>
                <th>Active Providers</th>
              </tr>
            </thead>
            <tbody>
              {skypointProvidersLoading ? (
                <tr>
                  <td>
                    <TableLoader />
                  </td>
                </tr>
              ) : skypointProviders?.length > 0 ? (
                skypointProviders?.map((providerData) => (
                  <tr key={providerData?._id}>
                    <td>{providerData?.name || ""}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>No Active Providers</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Box>
      </Box>
      <Flex className={classes.paginationRow}>
        <Box className="tableWidth">
          <CustomPagination
            data={staffCount}
            itemsPerPage={10}
            currentPage={staffCurrentPage}
            handlePageChange={(page) => setStaffCurrentPage(page)}
          />
        </Box>
        <Box className="tableWidth">
          <CustomPagination
            itemsPerPage={10}
            data={skypointProvidersCount}
            currentPage={providerCurrentPage}
            handlePageChange={(page) => setProviderCurrentPage(page)}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default SubscriptionDetailsCard;
